import { ProFormaGenericColumn } from 'views/ProFormaTable/components/ProFormaGenericTable/types';

export const BASE_FORECAST_COLUMNS: ProFormaGenericColumn[] = [
    {
        key: 'name',
        field: 'name',
        header: 'Revenue',
        format: 'none',
        isReadOnly: true,
    },
    {
        key: 'invisibleSF', field: 'invisibleSF', header: '', isHidden: true,
    },
    {
        key: 'untrended',
        field: 'untrended',
        header: '',
        format: 'currency',
        isReadOnly: true,
    },
    {
        key: 'trended',
        field: 'trended',
        header: '',
        format: 'currency',
        isReadOnly: true,
    },
    {
        key: 'sale',
        field: 'sale',
        header: '',
        format: 'currency',
        isReadOnly: true,
    },
];
